var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGuideMePersonP(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21.935 15.868",
    height: 59.973,
    width: 82.903,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h1440v6120H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h1440v6120H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    height: 1,
    width: 1,
    y: 0,
    x: 0,
    filterUnits: "objectBoundingBox",
    id: "a"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0",
    in: "SourceGraphic"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)",
    transform: "matrix(.09334 0 0 .09334 -15.961 -429.827)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3d3a54",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M377.152 4687.805h-2.093v82.78h2.093zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3d3a54",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M396.457 4698.355c.133 28.946-20.195 52.508-20.195 52.508s-20.543-23.375-20.676-52.32c-.133-28.945 20.195-52.504 20.195-52.504s20.543 23.371 20.676 52.317zM335.324 4726.754h-1.074v42.578h1.074zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3d3a54",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M345.254 4732.18c.066 14.89-10.387 27.007-10.387 27.007s-10.566-12.023-10.637-26.91c-.066-14.886 10.387-27.004 10.387-27.004s10.567 12.02 10.637 26.907zM356.531 4775c16.098 0 29.149-2.004 29.149-4.477 0-2.472-13.051-4.476-29.149-4.476-16.097 0-29.152 2.004-29.152 4.476 0 2.473 13.055 4.477 29.152 4.477zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2e2e3f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M358.934 4666.195c-2.47-4.18-7.356-4.375-7.356-4.375s-4.762-.61-7.812 5.758c-2.848 5.934-6.778 11.664-.633 13.05l1.11-3.456.687 3.715c.87.062 1.75.078 2.625.047 6.582-.215 12.847.062 12.644-2.305-.27-3.144 1.113-8.41-1.265-12.434zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fabdbd",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M350.043 4674.066s3.191 4.477 1.273 8.102c-1.914 3.625 4.47 7.46 4.47 7.46l4.683-10.23s-5.535-3.625-4.043-7.035zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fabdbd",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M352.168 4675.984a5.536 5.536 0 0 0 5.531-5.539 5.536 5.536 0 0 0-5.531-5.543 5.536 5.536 0 0 0-5.531 5.543 5.536 5.536 0 0 0 5.531 5.54zM333.023 4676.852l4.625-5.977s1.625-6.266 3.985-5.945c2.355.316-.934 7.511-.934 7.511l-4.594 6.614zM356.422 4756.348l1.492 7.886 3.191.856-.851-9.38zM388.55 4747.82l5.747 7.887 2.34 1.066 1.918-3.195-5.746-7.46zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#575987",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m355.148 4686.219-3.55-4.684s-6.875 1.274-7.516 1.91c-.637.64 1.703 12.364 1.703 12.364s.426 3.199 2.34 4.906l1.914 1.277 15.746-3.199.594-7.016a18.43 18.43 0 0 0-.942-7.554 18.38 18.38 0 0 0-3.906-6.532l-2.742.375zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#575987",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m344.934 4683.875-1.063-.43-4.894-.425s-1.704-.426-1.278-1.278c.426-.851.852-1.066 0-1.281-.851-.211-1.062-.426-.851-1.063.215-.64 1.492-1.921 1.492-1.921l-3.617-2.98s-.2.136-.516.394c-1.793 1.457-7.477 6.71-3.316 11.968 4.894 6.18 10.64 9.805 15.32 8.524zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2e2e3f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M349.617 4700.926v2.984s-1.918 3.625-1.277 7.035c.637 3.41.851 5.118.851 5.118a29.16 29.16 0 0 0 1.489 8.523c1.488 4.266-3.403 32.187 2.765 32.613 6.172.43 9.575.856 11.489-1.277 1.918-2.133-3.192-38.797-3.192-38.797s17.45 36.453 21.067 34.96c3.617-1.491 12.765-4.901 11.703-6.82-1.067-1.921-27.875-44.55-27.875-44.55l-.852-1.922zM359.828 4762.742s-3.402-.21-3.402.852c0 1.066-1.703 4.691-1.703 4.691s-1.278 4.262 2.125 3.836c3.406-.426 5.535-4.262 5.535-4.262l-.852-4.05zM395.36 4755.281s-2.977-1.918-2.766-.636c.215 1.277.426 4.687 1.918 4.902 1.488.21 5.957 1.492 6.168 1.918.215.426 5.32 2.129 5.32-.64 0-2.77-3.191-4.903-3.191-4.903l-3.618-2.77s-2.34-.214-2.765 1.278c-.426 1.492-1.067.851-1.067.851zM352.176 4665.379a3.535 3.535 0 0 0 3.535-3.54 3.538 3.538 0 0 0-3.535-3.538 3.537 3.537 0 0 0-3.531 3.539 3.534 3.534 0 0 0 3.53 3.539zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2e2e3f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M348.273 4660.91c0-.875.32-1.719.907-2.367a3.505 3.505 0 0 1 2.254-1.152 3.533 3.533 0 0 0-3.906 3.52 3.543 3.543 0 0 0 3.534 3.539c.122 0 .247-.01.372-.02a3.534 3.534 0 0 1-3.16-3.52zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2e2e3f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m357.844 4665.793-4.828-2.535-6.664 1.039-1.383 6.101 3.433-.132.961-2.243v2.204l1.582-.06.922-3.57.574 3.801 5.633-.117zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fabdbd",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m357.555 4701.422-7.446.2s-6.351 1.237-5.996-1.329c.356-2.57 6.555-1.672 6.555-1.672l6.781-1.035zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#575987",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M363.445 4677.328a1.593 1.593 0 0 1 1.75 1.094c1.457 4.601 5.95 20 1.489 22.11-5.254 2.488-9.09 2.378-9.09 2.378l-2.051-5.062 1.867-1.754 1.996-12.848.953-5.45zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000",
      fillOpacity: 0.4,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m362.063 4685.898-.852 8.528-7.445 3.195 8.296-1.918zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3d3a54",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M321.902 4657.75a9.982 9.982 0 0 1 5.82 4.234l.696 1.082.035.043 12.207 3.578a.894.894 0 0 1 .61 1.094l-.946 3.48a.938.938 0 0 1-.156.313.861.861 0 0 1-.266.227.823.823 0 0 1-.332.11.82.82 0 0 1-.347-.025l-12.211-3.422-1.227.465a10.946 10.946 0 0 1-7.047.242zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#575987",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M334.758 4667.848c.117-.395-.39-.895-1.133-1.11-.738-.219-1.434-.074-1.55.324-.114.395.394.891 1.132 1.11.742.219 1.438.07 1.55-.324zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3d3a54",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M334.137 4668.215a.514.514 0 0 0 0-1.028.509.509 0 0 0-.512.512c0 .285.227.516.512.516zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00854f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M322.922 4664.344c1.02-3.145.691-6.067-.727-6.531-1.422-.461-3.398 1.714-4.414 4.863-1.02 3.144-.695 6.07.727 6.531 1.418.461 3.394-1.715 4.414-4.863zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000",
      fillOpacity: 0.4,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M322.543 4664.234c.98-3.03.715-5.855-.578-6.472.078.012.156.027.23.05 1.418.462 1.746 3.387.727 6.532-1.02 3.148-2.996 5.324-4.414 4.863-.051-.02-.102-.039-.153-.062 1.399.18 3.223-1.93 4.188-4.91zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00854f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m322.063 4657.762-27.711-21.535a182.394 182.394 0 0 1-14.09-12.235c-7.899-7.543-18.621-13.574-31.11-16.785-30.332-7.8-54.359 6.031-65.289 26.344-16.703 31.035-29.504 81.402 44.551 54.593 16.195-5.863 32.59-6.488 45.02-9.574l45.011-9.297zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f0f0f0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M238.867 4621.523c.824 0 1.488-.668 1.488-1.492a1.489 1.489 0 1 0-2.976 0c0 .825.664 1.492 1.488 1.492zM267.8 4623.48h-.386v-.386h-.078v.386h-.387v.075h.387v.39h.078v-.39h.387zM306.738 4655.879h-.386v-.387h-.079v.387h-.386v.078h.386v.387h.079v-.387h.386zM303.973 4665.898h-.391v-.386h-.074v.386h-.387v.078h.387v.387h.074v-.387h.39zM185.031 4674.426h-.386v-.387h-.079v.387h-.386v.074h.386v.39h.079v-.39h.386zM202.055 4627.957h-.39v-.39h-.075v.39h-.387v.074h.387v.39h.074v-.39h.39zM268.227 4667.605h-.387v-.39h-.078v.39h-.387v.075h.387v.39h.078v-.39h.387zM227.586 4614.313h-.387v-.387h-.078v.386h-.387v.079h.387v.386h.078v-.386h.387zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e6e6e6",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m227.734 4645.004-.48.074c.148.969.27 1.957.355 2.937l.489-.043a41.865 41.865 0 0 0-.364-2.968zM226.414 4639.176l-.469.144c.285.938.54 1.899.754 2.856l.477-.11a44.337 44.337 0 0 0-.762-2.89zM224.305 4633.59l-.446.203c.41.894.793 1.809 1.141 2.727l.457-.172a42.74 42.74 0 0 0-1.152-2.758zM221.453 4628.348l-.41.261a46.099 46.099 0 0 1 1.496 2.543l.43-.234a42.572 42.572 0 0 0-1.516-2.57zM217.91 4623.547l-.375.316a41.877 41.877 0 0 1 1.836 2.317l.39-.293a42.675 42.675 0 0 0-1.85-2.34zM213.742 4619.27l-.324.363c.73.656 1.45 1.344 2.133 2.047l.351-.344a41.536 41.536 0 0 0-2.16-2.066zM209.04 4615.598l-.278.406a43.27 43.27 0 0 1 2.39 1.734l.301-.386c-.781-.61-1.594-1.2-2.414-1.754zM204.754 4613.05v.555c.508.266 1.012.543 1.508.829l.242-.422a44.424 44.424 0 0 0-1.75-.961zM227.77 4651.04l.488-.01c.008.491.008.991 0 1.476l-.488-.01c.008-.48.008-.973 0-1.461zM199.012 4686.996l-.485.074c.153.969.27 1.957.36 2.938l.484-.043a44.269 44.269 0 0 0-.36-2.97zM197.691 4681.172l-.468.14c.28.938.535 1.899.75 2.856l.48-.11a46.12 46.12 0 0 0-.762-2.886zM195.582 4675.582l-.445.203c.41.895.793 1.809 1.136 2.727l.461-.172c-.351-.93-.738-1.86-1.152-2.758zM192.73 4670.34l-.414.262a43.923 43.923 0 0 1 1.5 2.546l.43-.238a44.762 44.762 0 0 0-1.516-2.57zM189.188 4665.54l-.375.315a41.872 41.872 0 0 1 1.835 2.317l.391-.293a42.675 42.675 0 0 0-1.851-2.34zM185.02 4661.262l-.325.367c.73.652 1.45 1.34 2.133 2.043l.348-.344a41.457 41.457 0 0 0-2.156-2.066zM180.313 4657.594l-.274.402a41.755 41.755 0 0 1 2.387 1.735l.304-.383a43.706 43.706 0 0 0-2.417-1.754zM176.031 4655.043v.555c.508.265 1.012.543 1.504.832l.246-.426a47.406 47.406 0 0 0-1.75-.961zM199.043 4693.031l.488-.01c.012.492.012.992.004 1.477l-.488-.01c.008-.48.008-.973-.004-1.461zM297.313 4665.895l-.485.073c.152.97.27 1.958.36 2.938l.484-.043a43.958 43.958 0 0 0-.36-2.969zM295.992 4660.066l-.469.145c.282.937.536 1.898.75 2.855l.48-.109a46.262 46.262 0 0 0-.76-2.89zM293.883 4654.477l-.445.207c.41.89.792 1.808 1.136 2.726l.461-.176a44.644 44.644 0 0 0-1.152-2.757zM291.031 4649.238l-.414.262a43.793 43.793 0 0 1 1.5 2.543l.43-.234a43.43 43.43 0 0 0-1.516-2.57zM287.484 4644.438l-.37.316c.632.746 1.25 1.527 1.835 2.312l.39-.289a42.773 42.773 0 0 0-1.855-2.34zM283.32 4640.16l-.324.363c.73.657 1.445 1.344 2.129 2.043l.352-.34a42.986 42.986 0 0 0-2.157-2.066zM278.613 4636.488l-.273.406a41.755 41.755 0 0 1 2.387 1.735l.304-.387c-.785-.61-1.597-1.199-2.418-1.754zM274.328 4633.938v.554c.512.27 1.016.547 1.508.832l.246-.422a40.077 40.077 0 0 0-1.754-.965zM297.344 4671.93l.488-.012c.012.496.012.992.004 1.48l-.488-.01c.008-.48.008-.972-.004-1.46zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f0f0f0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M202.766 4647.61h-.36v-.36h-.07v.36h-.363v.07h.363v.363h.07v-.364h.36zM198.61 4669.43h-.364v-.364h-.07v.364h-.36v.07h.36v.36h.07v-.36h.363zM186.406 4688.55h-.36v-.363h-.07v.364h-.359v.07h.36v.363h.07v-.363h.36zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3d3a54",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M220.344 4664.297a26.223 26.223 0 0 1-4.266-17.684 26.178 26.178 0 0 1 8.266-16.203 26.133 26.133 0 0 1 16.812-6.89 26.093 26.093 0 0 1 17.23 5.753 26.18 26.18 0 0 1 9.329 15.614 26.23 26.23 0 0 1-3.082 17.93 26.146 26.146 0 0 1-14.004 11.59 26.105 26.105 0 0 1-18.16-.356 8.457 8.457 0 0 1-9.676 6.043 8.413 8.413 0 0 1-3.754-1.727 8.466 8.466 0 0 1-1.75-11.285 8.466 8.466 0 0 1 3.055-2.785zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00854f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M241.879 4634.723c5.992 0 10.113 3.328 10.113 8.113 0 3.168-1.535 5.363-4.488 7.105-2.781 1.618-3.723 2.801-3.723 4.852a1.2 1.2 0 0 1-.097.48 1.29 1.29 0 0 1-.684.688 1.278 1.278 0 0 1-.48.094h-3.063a1.258 1.258 0 0 1-1.262-1.219l-.004-.156c-.273-3.297.88-5.344 3.77-7.043 2.699-1.617 3.832-2.64 3.832-4.625 0-1.984-1.918-3.441-4.297-3.441-1.809 0-3.242.882-3.898 2.324a2.811 2.811 0 0 1-2.574 1.613c-2.079 0-3.446-2.21-2.477-4.047 1.535-2.906 4.773-4.738 9.332-4.738zm-4.2 27.43c0-1.84 1.532-3.297 3.419-3.297 1.902 0 3.433 1.44 3.433 3.296 0 1.856-1.531 3.297-3.433 3.297-1.903 0-3.418-1.441-3.418-3.297zm0 0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuideMePersonP);
export default __webpack_public_path__ + "static/media/guide-me-person-p.3e2e658804ddcca2f0f729ffe241a599.svg";
export { ForwardRef as ReactComponent };